/*
 * SPDX-FileCopyrightText: 2025 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

.ag-header-cell:hover .ag-header-cell-resize:after {
  background-color: var(--theme-table-header-splitter--background) !important;
}

.ag-header-cell .ag-header-cell-resize:hover:after {
  background-color: var(
    --theme-table-header-splitter--background--hover
  ) !important;
}
